module.exports = __webpack_public_path__ + "static/bg-restaurants-716a46409a327b84ff64254744e9d1c3.jpg";